import { handleStickyBar } from "./stickyBar";

// global variables
const $window = $(window);
const $stickyCta = $(".js-sticky-cta");

/**
* Initializes the sticky CTA component
* @returns {void}
*/
export default function () {
    if ($stickyCta || $stickyCta.length) {
        $window.on("scroll", handleStickyBar);
    }
}
